<template>
    <v-container class="fill-height back" fluid>
      <v-app-bar clipped-left app flat dark color="transparent">
        <img @click="home" class="logo" height="40px" src="../assets/logoirsmarket1.png" alt="logo"/>
        <v-spacer/>
        <v-toolbar-items>
        </v-toolbar-items>
      </v-app-bar>
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md6 lg8>
          <v-card class="elevation-2">
            <v-layout wrap>
              <v-flex xs12 sm12 md12 lg7>
                <div  style="height: 100%;background-size:100% 100%;background-image: url('https://cdn.irscloud.id/irsmarket/irsmarketlogin.png');" class="layout  align-center hidden-sm-and-down">
                </div>
              </v-flex>
              <v-flex xs12 sm12 md12 lg5>
                <div v-if="is2fa" class="otpverify">
                  <h1 class="text-center primary--text mt-5">VERIFY</h1>
                  <h2 class="text-center primary--text mt-2">Google Authenticator</h2>
                  <v-card-text>
                    <v-form v-model="valid" ref="form" lazy-validation @submit.prevent="handleSubmitVerify()">
                      <v-text-field
                          v-model="code"
                          name="code"
                          data-v-name="code"
                          type="text"
                          label="Kode OTP"
                          required>
                      </v-text-field>
                    </v-form>
                    <v-card-actions>
                      <v-btn  class="primary" @click.native="handleSubmitVerify()" :loading="loading">Kirim</v-btn>
                      <v-btn  class="red" dark @click.native="setState2fa(false)" :loading="loading">Batal</v-btn>
                    </v-card-actions>
                  </v-card-text>
                </div>
                <div v-else class="loginpanel">
                  <h1 class="text-center primary--text mt-5">IRSMarket</h1>
                  <v-card-text>
                    <div style="height:50px"></div>
                    <v-form v-model="valid" ref="form" lazy-validation @submit.prevent="handleSubmit()">
                      <v-text-field
                          v-model="email"
                          name="phone"
                          data-v-name="email"
                          type="email"
                          label="Email"
                          required>
                      </v-text-field>
                      <v-text-field
                          v-model="password" data-vv-name="password"
                          name="password"
                          required
                          :rules="passwordRules"
                          label="Password"
                          type="password"
                          @keypress="keyturun"
                      ></v-text-field>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  block class="primary" @click.native="handleSubmit()" :loading="loading">Masuk</v-btn>
                      </v-card-actions>
                      <div style="height:20px"></div>
                      <a href="#" class="" @click.prevent="forgot()">Lupa password</a>
                      <v-spacer></v-spacer>
                      <a href="#" class="" @click.prevent="register()">Buat Akun baru </a>
                      <div style="height:50px"></div>
                    </v-form>
                  </v-card-text>
                </div>
                <div class="versi">
                  v1.5.2
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      backgroundImageInlineStyle () {
        return 'background-image: url("./assets/login_img01.jpeg");'
      },
      params: {
        client_id: '805888338719-bhpm5nkk9t9o9bq1kcptkvi36ep82voj.apps.googleusercontent.com'
      },
      renderParams: {
        width: 240,
        height: 40,
        longtitle: true
      },
      code: '',
      valid: false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v =>
          // eslint-disable-next-line no-useless-escape
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'E-mail must be valid'
      ],
      password: '',
      passwordRules: [v => !!v || 'Password is required'],
      submitted: false,
      items: [
        {
          src: '/static/banner/banner0.jpg'
        },
        {
          src: '/static/banner/banner2.jpg'
        }
      ]
    }
  },
  computed: {
    ...mapState('authentication', ['status', 'loading', 'is2fa'])
  },
  mounted () {
    this.setState2fa(false)
  },
  created () {
  },
  methods: {
    ...mapActions('authentication', ['doVerifyOTPLogin', 'dologin', 'logout', 'dologinFacebook', 'dologinGoogle', 'setState2fa']),
    handleSubmitVerify () {
      console.log(this.code.length)
      if (this.code.length === 6) {
        this.doVerifyOTPLogin(this.code)
      }
    },
    handleSubmit () {
      this.submitted = true
      const { email, password } = this
      if (email && password) {
        this.dologin({ email, password })
      }
    },
    keyturun (e) {
      if (e.code === 'Enter') {
        this.handleSubmit()
      }
    },
    register () {
      this.$router.push('/register')
    },
    forgot () {
      this.$router.push('/forgot')
    },
    home () {
      location.href = 'https://irsmarket.com'
    },
    login () {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.back {
  background-image: linear-gradient(to right, rgba(5, 11, 31, 0.8), rgba(5, 11, 31, 0.8)), url("https://irsx.sgp1.digitaloceanspaces.com/bglogintech.jpeg");
  background-size: cover;
}
a {
  text-decoration: none;
}
.versi {
  bottom: 0px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
}
</style>
